import { useHomeContext } from "../contexts/HomeContext";
import CardLoader from "./CardLoader";
import Container from "./Container";
import Text from "./Text";

interface ICardProps {
    isLoading?: boolean;
    title?: string;
    subTitle?: string;
    children: React.ReactNode;
    action?: React.ReactNode;
    showEmptyWallet?: boolean;
    className?: string;
}

export default function Card({ isLoading, title, className, subTitle, children, action, showEmptyWallet = true }: ICardProps) {
    const homeContext = useHomeContext();

    return (
        <Container wrap cardResponsive flexColumn className={`bg-white border-round p-3 ${className ? className : "justify-content-center align-items-center"}`} gap={4} relative>
            {
                isLoading
                    ? (
                        <CardLoader />
                    )
                    : (
                        !homeContext.wallet?.totalValue && showEmptyWallet
                            ? <Text>Sua carteira está vazia</Text>
                            : title && subTitle ? 
                                (
                                    <Container flexColumn fullWidth gap={3}>
                                        {
                                            (
                                                <Container between>
                                                    <Container flexColumn gap={1}>
                                                        <Text size="xl" color="600" fontWeight="semibold">
                                                            {title}
                                                        </Text>
                                                        <Text size="sm" color="600" fontWeight="light">
                                                            {subTitle}
                                                        </Text>
                                                    </Container>

                                                    <Container>
                                                        {action}
                                                    </Container>
                                                </Container>
                                            )
                                        }

                                        <Container wrap gap={2} fullWidth>
                                            { children }
                                        </Container>
                                    </Container>
                                )
                                : <>{children}</>
                    )
            }
        </Container>
    )
}
